<template>
  <b-container v-if="!initialized || invitedMeetingsCount" fluid class="invited-meetings-container mt-4 pt-3">
    <b-row>
      <b-col cols="12">
        <proa-heading sub class="mb-3 pb-1">
          {{ $t('pages.mySpace.invitedMeetings') }}
          <span v-show="initialized && invitedMeetingsCount">（{{ invitedMeetingsCount }}）</span>
        </proa-heading>
        <div v-if="!initialized" class="loading-wrapper">
          <proa-loading class="loading"/>
        </div>
        <invited-meetings-card
          v-else
          :invitedMeetings="invitedMeetings"
          :limited="limited"
          :enableChangeLimit="invitedMeetingsCount > 2"
          @changeLimited="toValue => limited = toValue"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VideoRoom from '@/store/models/VideoRoom'
import InvitedMeetingsCard from '@/components/molecules/InvitedMeetingsCard'

export default {
  name: 'InvitedMeetings',
  components: {
    InvitedMeetingsCard
  },
  computed: {
    invitedMeetingsCount: function() {
      return VideoRoom.query().where((videoRoom) => {
        return videoRoom.invitedByUserId(this.signedInUser.id)
      }).count()
    },
    invitedMeetings: function() {
      if (!this.initialized) return []
      return VideoRoom.query().where((videoRoom) => {
        return videoRoom.invitedByUserId(this.signedInUser.id)
      }).orderBy('startAt', 'asc').limit(this.limited ? 2 : this.invitedMeetingsCount).get()
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  data(){
    return {
      initialized: false,
      limited: true
    }
  },
  methods: {
    ...mapActions({
      apiGetInvitedVideoRooms: 'entities/videoRooms/invitedIndex'
    })
  },
  async created() {
    await this.apiGetInvitedVideoRooms()
    this.initialized = true
  }
}
</script>

<style scoped lang="scss">
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;

  .loading {
    width: 80px;
    height: 80px;
  }
}
.invited-meetings-container {
  padding: 0;
}
</style>
